<template>
  <div>
    <application-composition-cylinder
      :id="getComposition.id"
      :compositionName="getComposition.name"
      :total="getRemainingValue"
      :subtracted="subtracted"
      :selected="true"
    />
    <br>
    <br>
    <form @submit.prevent="onSubmit()">
      <applications-tree
        :data="treeApplications"
        :max="getRemainingValue"
        :remaining="getRemainingValue"
        :sliderStatusId="0"
      ></applications-tree>
      <div class="row">
        <div class="col-md-6">
          <base-button radius="bl" component-class="blue" @click.native="$router.go(-1)">
            <i class="fas fa-arrow-left mr-3"></i> Back
          </base-button>
        </div>
        <div class="col-md-6 text-right">
          <base-button
            radius="br"
            component-class="green filled"
            type="submit"
            :disabled="isSliderSumHighQty"
          >Update
          </base-button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import ApplicationCompositionCylinder from '../ApplicationCompositionCylinder';
import BaseButton from '@/components/inputs/button/BaseButton';
import ApplicationsTree from '@/components/inputs/tree/ApplicationsTree';

export default {
  props: {
    groupedUserCompositions: {
      type: Object,
      required: true
    },
    remainingMaterials: {
      type: Number,
      default: 0
    },
    sumInSliders: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      subtracted: 0,
    };
  },

  computed: {
    ...mapState({
      currentApplication: state => state.applicationModule.currentApplication
    }),
    getRemainingValue() {
      const { remainingVolume } = this.groupedUserCompositions[this.currentApplication.compositionId];
      const { applicationLinksSum } = this.currentApplication;
      return remainingVolume + applicationLinksSum;
    },
    isSliderSumHighQty() {
      return this.sumInSliders > this.getRemainingValue;
    },
    getComposition() {
      return this.groupedUserCompositions[
        this.currentApplication.compositionId
      ];
    },
    treeApplications() {
      return this.$store.getters['applications/treeApplications'];
    }
  },

  watch: {
    sumInSliders(newValue) {
      this.subtracted = newValue;
    },
    isSliderSumHighQty(newValue) {
      this.$emit('isHighQty', newValue);
    }
  },

  methods: {
    ...mapActions({
      getApplicationLinks: 'userApplications/getApplicationLinks',
    }),
    async onSubmit() {
      try {
        await this.$store.dispatch(
          'userApplications/update',
          this.currentApplication.compositionId
        );
        this.getApplicationLinks();
        this.$router.push({ name: 'user.applications' });
      } catch (error) {
        console.error(error);
      }
    }
  },

  mounted() {
    const applications = this.currentApplication.applicationsLink.map(link => ({
      id: link.application_id,
      volume: link.volume
    }));
    this.$store.commit('userApplications/current', {
      application_id: this.currentApplication.id,
      applications
    });
    this.$emit('isHighQty', false);
  },

  components: {
    'base-button': BaseButton,
    'applications-tree': ApplicationsTree,
    'application-composition-cylinder': ApplicationCompositionCylinder
  }
};
</script>
